import { styled } from '@material-ui/core';

import { Typography } from 'shared/components';

export const EditHeader = styled(Typography)(({ theme: { typography: { h4 } } }) => ({ ...h4 }));
